import { useFormContext, useFormState, useWatch } from "react-hook-form";

import { QuoteRequestLineFormData } from "#modules/quoteRequestLines/types/QuoteRequestLineFormData";

export const useProductLineStatus = (index: number, productLineId: string | undefined) => {
  const { control } = useFormContext<QuoteRequestLineFormData>();
  const productLines = useWatch({ control, name: "productLines" });

  const currentProductLine = productLines?.[index];

  const { dirtyFields } = useFormState<QuoteRequestLineFormData>({
    name: "productLines",
  });

  const isDirty =
    Array.isArray(dirtyFields.productLines) &&
    (dirtyFields.productLines[index]?.quantity ||
      dirtyFields.productLines[index]?.name ||
      dirtyFields.productLines[index]?.price ||
      dirtyFields.productLines[index]?.fixedPrice);

  const isSavable =
    currentProductLine?.quantity &&
    currentProductLine.quantity > 0 &&
    currentProductLine.name &&
    currentProductLine.price !== undefined;

  const isNew = productLineId === undefined;

  return { isDirty, isSavable, isNew };
};
